import request from '@/config/axios'

// 上传文件
export const uploadFile = (data: any) => {
  return request.upload({ url: '/infra/file/upload', data })
}